// extracted by mini-css-extract-plugin
module.exports = {"app-header":"AppHeader_app-header__3VHIc"};